import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { Clock, Smartphone, Zap, MousePointer } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const featureIcons = [Clock, Smartphone, Zap, MousePointer];

export const FeaturesSection = () => {
  const { language } = useLanguage();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section 
      id="features"
      ref={ref}
      className="py-24 md:py-32 bg-slate-50 dark:bg-slate-950 theme-transition"
      data-testid="features-section"
    >
      <div className="section-container">
        {/* Section Header */}
        <div className={`text-center mb-16 ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}>
          <h2 className="section-title mb-4" data-testid="features-title">
            {translations.features.title[language]}
          </h2>
          <p className="section-subtitle mx-auto">
            {translations.features.subtitle[language]}
          </p>
        </div>

        {/* Features Bento Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {translations.features.items.map((feature, index) => {
            const Icon = featureIcons[index];
            
            return (
              <div
                key={index}
                className={`group product-card card-hover text-center ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}
                style={{ animationDelay: `${index * 0.1}s` }}
                data-testid={`feature-card-${index}`}
              >
                <div className="feature-icon mx-auto mb-4 group-hover:scale-110 transition-transform">
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
                  {feature.title[language]}
                </h3>
                <p className="text-sm text-slate-600 dark:text-slate-400">
                  {feature.description[language]}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
